<script lang="ts">
  export let name: keyof typeof icons;
  export let width = "24px";
  export let height = "24px";
  export let focusable: string | number | null | undefined = undefined;
  let icons = {
    "text-minus": {
      box: 24,
      props: {
        fill: "none",
        stroke: "#1e97db",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
      svg: `<path d="M11 12H3"/><path d="M16 6H3"/><path d="M16 18H3"/><path d="M21 12h-6"/>`,
    },
    sparkles: {
      box: 24,
      props: {
        fill: "none",
        stroke: "#6554c0",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
      svg: `<path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>`,
    },
  } as const;
  let displayIcon = icons[name];
</script>

<svg
  class={$$props.class}
  {...displayIcon.props}
  {focusable}
  {width}
  {height}
  viewBox="0 0 {displayIcon.box} {displayIcon.box}">{@html displayIcon.svg}</svg
>
